import moment from 'moment';

const datemask = function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        priority: 1000,
        link: function(scope, iElement, iAttrs, ngModelCtrl) {
            var format, momentFormat, isoFormat;
            var type = iAttrs.format || 'date';
            if (type === 'datetime') {
                momentFormat = 'DDMMYYYYHHmm';
                format = 'DD.MM.YYYY HH:mm';
                isoFormat = 'YYYY-MM-DDTHH:mm:ss';
            } else {
                momentFormat = 'DDMMYYYY';
                format = 'DD.MM.YYYY';
                isoFormat = 'YYYY-MM-DD';
            }

            iElement.on('keyup', event => {
                if (event.keyCode === 32 && ngModelCtrl.$viewValue === iAttrs.uiMaskPlaceholder) {
                    let value = moment().format(momentFormat);
                    ngModelCtrl.$setViewValue(value);
                    ngModelCtrl.$render();
                }
            });

            function parseViewValue(value) {
                var d = moment(value, momentFormat, true);
                if (d.isValid()) {
                    return d.format(isoFormat);
                }

                return value;
            }

            function formatViewValue(value) {
                var d = moment(value, isoFormat, true);
                if (d.isValid()) {
                    return d.format(format);
                }
            }

            function validateValue(modelValue, viewValue) {
                var value = modelValue;
                if (value === null || angular.isUndefined(value) || value === '') {
                    return true;
                }

                var d = moment(value, isoFormat, true);
                return d.isValid();
            }

            ngModelCtrl.$parsers.push(parseViewValue);
            ngModelCtrl.$formatters.push(formatViewValue);
            ngModelCtrl.$validators.datemask = validateValue;
        }
    };
};

export { datemask };



// WEBPACK FOOTER //
// ./app/components/common/forms/datemask.js